import { useBrand } from '../hooks/useBrand';

// Brand lockup: CMS logo (logo_on_1 — the white/dark-background monogram) +
// the "<acronym> MMS" wordmark pulled from CMS settings. Used in the shell,
// login and SSO landing so nothing hardcodes a brand name.
const SIZES = {
  sm: { img: 'h-6', text: 'text-sm' },
  md: { img: 'h-7', text: 'text-base' },
  lg: { img: 'h-10', text: 'text-xl' },
};

export default function Brand({ size = 'md', className = '', linkToHome = false }) {
  const brand = useBrand();
  const s = SIZES[size] || SIZES.md;
  const inner = (
    <>
      {brand.logo ? (
        <img
          src={brand.logo}
          alt={brand.name || brand.wordmark}
          className={`${s.img} w-auto object-contain`}
          draggable={false}
        />
      ) : null}
      <span className={`font-semibold tracking-tight ${s.text}`}>{brand.wordmark}</span>
    </>
  );
  // In the shell/top-nav, the logo links back to the brand homepage (leaves the tool).
  // Opt-in via `linkToHome` so login/SSO/footer lockups stay plain (not links).
  if (linkToHome && brand.site_url) {
    return (
      <a href={brand.site_url} title="Back to home"
         className={`flex items-center gap-2.5 no-underline text-inherit ${className}`}>
        {inner}
      </a>
    );
  }
  return <div className={`flex items-center gap-2.5 ${className}`}>{inner}</div>;
}
